import NAME from "./constants";

export const getMyAnnotationRows = store => store[NAME].myAnnotationRows;
export const getMyAnnotationTypes = store => store[NAME].types;
export const getMyAnnotationSubtypes = store => store[NAME].subtypes;
export const getMyAnnotationCategories = store => store[NAME].categories;
export const loading = store => store[NAME].gettingMyAnnotations;
